/**
 * @generated SignedSource<<0575fa98aaf0273f3adfb7e65e2107c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CampaignTabs = "Closing" | "Finished" | "New" | "Popular" | "Recommended";
export type CategoryTypes = "body_care" | "child_teaching" | "dance" | "diet" | "diy" | "fashion" | "gadget" | "game" | "gourmet_sweet_report" | "hair_care" | "kids" | "life_style" | "makeup" | "movie" | "nail" | "other" | "pet" | "ranking" | "skin_care" | "travel" | "yoga";
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "tiktok_go" | "twitter" | "youtube";
export type CampaignsQuery$variables = {
  after?: string | null;
  first?: number | null;
  selectedCategories?: ReadonlyArray<CategoryTypes> | null;
  selectedHasMoney?: boolean | null;
  selectedHasProduct?: boolean | null;
  selectedPrefectures?: ReadonlyArray<string> | null;
  selectedSns?: ReadonlyArray<ParentMediaType> | null;
  tab?: CampaignTabs | null;
};
export type CampaignsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CampaignsCampaigns">;
};
export type CampaignsQuery = {
  response: CampaignsQuery$data;
  variables: CampaignsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedCategories"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedHasMoney"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedHasProduct"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedPrefectures"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "selectedSns"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tab"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "selectedCategories",
    "variableName": "selectedCategories"
  },
  {
    "kind": "Variable",
    "name": "selectedHasMoney",
    "variableName": "selectedHasMoney"
  },
  {
    "kind": "Variable",
    "name": "selectedHasProduct",
    "variableName": "selectedHasProduct"
  },
  {
    "kind": "Variable",
    "name": "selectedPrefectures",
    "variableName": "selectedPrefectures"
  },
  {
    "kind": "Variable",
    "name": "selectedSns",
    "variableName": "selectedSns"
  },
  {
    "kind": "Variable",
    "name": "tab",
    "variableName": "tab"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CampaignsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "CampaignsCampaigns"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CampaignsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CampaignConnection",
        "kind": "LinkedField",
        "name": "campaigns",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CampaignEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Campaign",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentMediaType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gifting",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isFavoriteCheck",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Banner",
                    "kind": "LinkedField",
                    "name": "banners",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "file",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MCategory",
                    "kind": "LinkedField",
                    "name": "mCategory",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SocialNetwork",
                    "kind": "LinkedField",
                    "name": "socialNetwork",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "recruitmentEndOn",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "tab",
          "selectedSns",
          "selectedCategories",
          "selectedHasMoney",
          "selectedHasProduct",
          "selectedPrefectures"
        ],
        "handle": "connection",
        "key": "CampaignsList_campaigns",
        "kind": "LinkedHandle",
        "name": "campaigns"
      }
    ]
  },
  "params": {
    "cacheID": "903b3b607d67ce81672bcc8a420b205f",
    "id": null,
    "metadata": {},
    "name": "CampaignsQuery",
    "operationKind": "query",
    "text": "query CampaignsQuery(\n  $after: String\n  $first: Int\n  $selectedCategories: [CategoryTypes!]\n  $selectedHasMoney: Boolean\n  $selectedHasProduct: Boolean\n  $selectedPrefectures: [String!]\n  $selectedSns: [ParentMediaType!]\n  $tab: CampaignTabs\n) {\n  ...CampaignsCampaigns_1hOoAx\n}\n\nfragment CampaignBigCampaign on Campaign {\n  id\n  parentMediaType\n  title\n  gifting\n  prType\n  isFavoriteCheck\n  banners {\n    file\n    id\n  }\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    recruitmentEndOn\n    id\n  }\n}\n\nfragment CampaignCampaign on Campaign {\n  id\n  parentMediaType\n  title\n  gifting\n  prType\n  isFavoriteCheck\n  banners {\n    file\n    id\n  }\n  mCategory {\n    name\n    id\n  }\n  socialNetwork {\n    recruitmentEndOn\n    id\n  }\n}\n\nfragment CampaignsCampaigns_1hOoAx on Query {\n  campaigns(first: $first, after: $after, tab: $tab, selectedSns: $selectedSns, selectedCategories: $selectedCategories, selectedHasMoney: $selectedHasMoney, selectedHasProduct: $selectedHasProduct, selectedPrefectures: $selectedPrefectures) {\n    edges {\n      node {\n        id\n        ...CampaignBigCampaign\n        ...CampaignCampaign\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e756eea6bd1643881df1ba5735f21ab1";

export default node;
